import styled from "styled-components";

export const Container = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  background: transparent;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 2rem;
  font-weight: bold;
  color: #203b34;
  text-transform: uppercase;
`;

export const SubTitle = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  color: #203b34;
  /* text-transform: uppercase;
  text-decoration: underline; */
`;

export const ButtonNormal = styled.button`
  width: 100%;
`;

export const ContainerForm = styled.div`
  /* text-align: center; */
  min-height: 120px;
  background: #f7f7f78f;
  border-radius: 10px;
  padding: 20px 20px 30px 20px;
  margin: 0; 
  width: 100%;
  max-width: 600px;
`;
